var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTheme(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 21.5H5C3.895 21.5 3 20.605 3 19.5V16.5C3 15.395 3.895 14.5 5 14.5H19C20.105 14.5 21 15.395 21 16.5V19.5C21 20.605 20.105 21.5 19 21.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.132 14.5H6.998C5.895 14.5 5 13.605 5 12.502V9.498C5 8.395 5.895 7.5 6.998 7.5H17.002C18.105 7.5 19 8.395 19 9.498V12.632C19 13.664 18.164 14.5 17.132 14.5V14.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.232 2.5C14.29 2.5 15 3.431 15 4.298C15 6.058 12.054 7.5 12 7.5C11.946 7.5 9 6.059 9 4.298C9 3.431 9.71 2.5 10.768 2.5C11.373 2.5 11.77 2.783 12 3.035C12.23 2.783 12.627 2.5 13.232 2.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.5C20.457 17.5 19.914 17.667 19.5 18C19.086 18.333 18.543 18.5 18 18.5C17.457 18.5 16.914 18.333 16.5 18C16.086 17.667 15.543 17.5 15 17.5C14.457 17.5 13.914 17.667 13.5 18C13.086 18.333 12.543 18.5 12 18.5C11.457 18.5 10.914 18.333 10.5 18C10.086 17.667 9.543 17.5 9 17.5C8.457 17.5 7.914 17.667 7.5 18C7.086 18.333 6.543 18.5 6 18.5C5.457 18.5 4.914 18.333 4.5 18C4.086 17.667 3.543 17.5 3 17.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.5C18.578 10.5 18.156 10.667 17.833 11C17.511 11.333 17.089 11.5 16.666 11.5C16.244 11.5 15.822 11.333 15.499 11C15.176 10.667 14.755 10.5 14.332 10.5C13.909 10.5 13.488 10.667 13.165 11C12.843 11.333 12.421 11.5 11.998 11.5C11.575 11.5 11.154 11.333 10.831 11C10.509 10.667 10.087 10.5 9.664 10.5C9.241 10.5 8.822 10.667 8.5 11C8.178 11.333 7.756 11.5 7.333 11.5C6.911 11.5 6.489 11.333 6.166 11C5.844 10.667 5.422 10.5 5 10.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.e23faa23.svg";
export { ForwardRef as ReactComponent };